export { default as GDMPageCardHeader } from './GDMPageCardHeader';

export type { GDMPageCardHeaderComponent, GDMPageCardHeaderProps } from './GDMPageCardHeader.type';
